































import { HTTP_RESPONSE } from "@/services/Enums";
import { General } from "@/services/General";
import axios from "axios";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OtpLogin extends Vue {
    @Prop({ required: true})
    usernameProp: string;

    otpCode: string = null;
    loading: boolean = false;
    isSaveClicked: boolean = false;

    mounted() {
    }

    getMessage(data: any) {        
        switch (data.response) {
            case HTTP_RESPONSE.LoginFailed:
                let msg = 'Login failed';
                if (data.message != null && data.message != "") msg = msg + " - " + data.message;
                return msg;
            case HTTP_RESPONSE.UserDoesntExist:
                return 'User doesn\'t exist';
            case HTTP_RESPONSE.UserLockedOut:
                return 'User is now blocked, too many incorrect attempts. Use "Forgot Password" link to reset your password.';
            case HTTP_RESPONSE.InvalidOTPCode:
                return 'Security code (OTP) not valid';
        }
        return 'Error code: ' + data.response;
    }

    async loginOtp() {
        this.isSaveClicked = true;
        if(this.isValidForm()) {
            try {
                this.loading = true;
                let response:any = await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/auth/LoginExternal2FA?otpCode=' + this.otpCode + '&username=' + this.usernameProp),
                    withCredentials: true,
                    responseType: 'json'
                });

                if (response.data.response == HTTP_RESPONSE.LoggedIn) {
                    await General.AuthenticateUser(response, this.$route, this.$router) 
                } else {
                    this.$fire({
                        text: this.getMessage(response.data),
                        type: "error"
                    });
                }
                this.loading = false;
                this.isSaveClicked = false;
            } catch (error) {
                this.loading = false;
                General.showAlertDanger(error, this);
            }
        }
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    isValidForm() {
        let isValid: boolean = true;
        if(this.CheckIsNullOrEmpty(this.otpCode)) {
            isValid = false;
        }
        return isValid
    }
    
    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text.toString() === '') return true;
        return false;
    }
}
